import {} from "react-hook-form";
import { FieldValues, Path, PathValue, useFormContext } from "react-hook-form";

import { RecommendedNumberInputController } from "#shared/view/designSystem/inputs/RecommendedNumberInputController";

type Props<T extends FieldValues> = {
  name: string;
  label: string;
  widthKey: string;
  heightKey: string;
  computedValue?: { value: PathValue<T, Path<T>> | null; message?: string };
  companyValue?: { value: PathValue<T, Path<T>> | null; message?: string };
  required?: boolean;
  disabled?: boolean;
  onBlur?: () => void;
  inlineLabel?: boolean;
  small?: boolean;
  style?: React.CSSProperties;
  onChange?: (value: number) => void;
};

export function RecommendedDiameterInputController<T extends FieldValues>({
  name,
  label,
  widthKey,
  heightKey,
  computedValue,
  companyValue,
  required,
  disabled,
  onBlur,
  style,
  onChange,
  ...props
}: Props<T>) {
  const formMethods = useFormContext();

  const { control, setValue } = formMethods;

  return (
    <RecommendedNumberInputController
      control={control}
      name={name}
      label={label}
      unit="mm"
      precision={2}
      required={required}
      computedValue={computedValue}
      companyValue={companyValue}
      onBlur={onBlur}
      onChange={(value) => {
        setValue(widthKey, value);
        setValue(heightKey, value);
        onChange?.(value);
      }}
      disabled={disabled}
      style={style}
      {...props}
    />
  );
}
